// src/pages/investmentFunds/dashboard/HoldingsDashboard.jsx

import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool, shape } from "prop-types";
import { isIOS } from "react-device-detect";
import { push } from "connected-react-router";

import { selectors as investmentfundsSelectors, actions as investmentfundsActions } from "reducers/investmentfunds";

import PageLoading from "pages/_components/PageLoading";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import Action from "pages/_components/Action";
import Dropdown from "pages/_components/Dropdown";

import DashboardTabs from "./DashboardTabs";
import AccountsOfficer from "./AccountsOfficer";

class HoldingsDashboard extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        accountsOfficer: shape({}).isRequired,
    };

    componentDidMount() {
        this.props.dispatch(investmentfundsActions.dashboardPre());
    }

    renderHeader = () => {
        const { dispatch } = this.props;
        return (
            <ResponsiveHeader id="investmentFunds.investmentSummary.title" backLinkTo="/desktop">
                <DesktopButtons buttonExtra>
                    <Dropdown
                        bsStyle="link"
                        label="investmentFunds.investorTest.dashboard.moreOptions"
                        buttonClass="outline btn-lg"
                        pullRight>
                        <Button
                            onClick={() => dispatch(push("/investmentFunds/listAccounts"))}
                            label="investmentFunds.investorTest.dashboard.moreOptions.yourAccounts"
                            className="dropdown__item-btn"
                            bsStyle="link"
                        />
                        <Button
                            onClick={() => dispatch(push("/profileInfo"))}
                            label="investmentFunds.investorTest.dashboard.moreOptions.aboutYourProfile"
                            className="dropdown__item-btn"
                            bsStyle="link"
                        />
                        <Button
                            onClick={() => dispatch(push("/investmentFunds/accounts/noProfileInfo"))}
                            label="investmentFunds.investorTest.dashboard.moreOptions.openAccount"
                            className="dropdown__item-btn"
                            bsStyle="link"
                        />
                    </Dropdown>
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action
                        labelKey="investmentFunds.investorTest.dashboard.moreOptions.yourAccounts"
                        to="/investmentFunds/listAccounts"
                    />
                    <Action
                        labelKey="investmentFunds.investorTest.dashboard.moreOptions.aboutYourProfile"
                        handleClick={() => dispatch(push("/profileInfo"))}
                    />
                    <Action
                        labelKey="investmentFunds.investorTest.dashboard.moreOptions.openAccount"
                        to="/investmentFunds/accounts/noProfileInfo"
                    />
                </MobileButtons>
            </ResponsiveHeader>
        );
    };

    renderTabs = () => {
        const { accountsOfficer } = this.props;
        return (
            <MainContainer className="desktop loans-detail-container">
                <AccountsOfficer accountsOfficer={accountsOfficer} isDesktop />
                <DashboardTabs />
            </MainContainer>
        );
    };

    render() {
        const { fetching } = this.props;
        return (
            <PageLoading loading={fetching}>
                <Notification scopeToShow="investmentfunds" />
                {this.renderHeader()}
                {this.renderTabs()}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    fetching: investmentfundsSelectors.getFetching(state),
    accountsOfficer: investmentfundsSelectors.getAccountsOfficer(state),
});

export default connect(mapStateToProps)(HoldingsDashboard);
